module.exports = __webpack_public_path__ + "img/empty-state.c4764d6f.svg";